import React from 'react';
import { Badge } from '@superops/ui-design-system';
import { PatchSeverityColorMap } from '@nile/rmm/src/modules/alert-management/constants/constants';

function PatchSeverityCell(props) {
  const { cell } = props;

  const severity =
    cell?.row?.original?.severity || cell?.row?.original?.patchDetail?.severity;

  return (
    <Badge size="large" uppercase status={PatchSeverityColorMap[severity]}>
      {severity}
    </Badge>
  );
}

export default PatchSeverityCell;
